<template>
  <!-- 
    画面: ポイント履歴
    用途: 一般ユーザーが自身のポイント履歴を参照する
   -->
  <div>
    <CRow>
      <CCol md="6">
        <CCard>
          
          <!-- #region Header -->
          <CCardHeader>
            <CRow>
              <CCol lg="6">
                <h3 class="card-title mb-3">所有ポイント: {{current.points}}</h3>
              </CCol>
            </CRow>
          </CCardHeader>
          <!-- #endregion Header -->

          <!-- #region Table -->
          <CCardBody>
            <CDataTable
              class="mb-0 table-outline"
              hover
              head-color="light"
              itemps-per-page-select
              sorter
              pagination
              :items="tableItems"
              :fields="tableFields"
              :items-per-page="20"
              :sorterValue.sync="tableSorter"
              v-if="!loading"
            >
              <template #lastModifiedDate="{item}">
                <td class="text-right">
                  <strong>{{new Date(item.lastModifiedDate) | dateFormat('YYYY/MM/DD HH:mm:ss')}}</strong>
                </td>
              </template>
              <td slot="pointsWithDirection" slot-scope="{item}" class="text-right">
                <template v-if="item.increase">
                  <strong class="text-success">{{item.pointsWithDirection}}</strong>
                </template>
                <template v-else>
                  <strong class="text-danger">{{item.pointsWithDirection}}</strong>
                </template>
              </td>
              <td slot="pointsAfter" slot-scope="{item}" class="text-right">
                <strong>{{item.pointsAfter}}</strong>
              </td>
            </CDataTable>
          </CCardBody>
          <!-- #endregion Table -->

        </CCard>

      </CCol>
    </CRow>

    <!-- #region Session timeout -->
     
    <!-- #endregion Session timeout -->

  </div>
</template>

<script>
import axios from "axios";
// import MainChart from "./components/chart";

export default {
  name: "Dashboard",
  components: { },
  data() {
    return {
       

      //#region Flag

      loading: false,

      //#endregion Flag

      //#region Config

      loadingsvg: require("../assets/loading.svg"),
      collapseDuration: 0,
      tableSorter: {
        column: "lastModifiedDate",
        asc: false,
      },

      //#endregion Config

      //#region Header
      
      current: {},

      //#endregion Header

      //#region Table

      tableItems: [],
      tableFields: [
        { key: "lastModifiedDate", label: "更新日", _classes: "text-right bg-light" },
        { key: "pointsWithDirection", label: "更新値", _classes: "text-center bg-light" },
        { key: "pointsAfter", label: "残ポイント", _classes: "text-center bg-light" },
      ],

      //#endregion Table

    };
  },

  methods: {

    //#region Request

    /** ポイント一覧取得 */
    getPointsRecords: function () {
      const url = "/rest/currentuser/points/history";
      
      this.loading = true;

      axios
        .get(url, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          const datas = resp.data;
          console.log(datas);

          this.tableItems = datas;

          this.loading = false;
          console.log(this.tableItems)
        })
        .catch((err) => {
           

          console.log(err);
          this.loading = false;
        });
    },
    
    /** 所有ポイント取得 */
    getRemainPoints: function () {
      var url = "/rest/currentuser/points";
      this.loading = true;
      
      axios.get(url, {
        headers: { Authorization: `Bearer ${this.$keycloak.token}` },
      })
        .then((resp) => {
          console.log(resp.data);
          this.current = resp.data;
          this.loading = false;
        })
        .catch((err) => {
           

          console.log(err);
          this.loading = false;
        });
    },

    //#endregion Request

  },

  beforeMount() {
    this.getRemainPoints();
    this.getPointsRecords();
  },
};
</script>
